import { IconSvgProps } from "../types";
export const Notepad = ({ size }: IconSvgProps) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
        fill="none"
        id="icon-notepad"
        width={size}
        height={size}
        version="1.1"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.67 10.3564H8.02332V23.9998H21.6666V10.3564H21.67ZM10.95 14.7431H18.7466V13.2798H10.95V14.7431ZM10.95 17.9098H18.7466V16.4464H10.95V17.9098ZM15.8233 21.0764H10.95V19.6131H15.8233V21.0764Z"
            fill="#BF63F3"
        />
        <path
            d="M18.9833 15.1633L16 16L16.8367 13.0167L24.2767 5.57666L26.4233 7.72333L18.9833 15.1633Z"
            fill="#1868DB"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.4967 10.3564L16.8367 13.0164L16.7633 13.2798H18.7467V14.7431H16.3533L16 15.9998L18.9833 15.1631L21.67 12.4764V10.3564H19.4967Z"
            fill="#09326C"
        />
    </svg>
);
